// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCiwH-3DyChnPe-k85jjVaO6IxWo53AyKs",
  authDomain: "notnetflix-6e015.firebaseapp.com",
  projectId: "notnetflix-6e015",
  storageBucket: "notnetflix-6e015.appspot.com",
  messagingSenderId: "146051431879",
  appId: "1:146051431879:web:ae343f8fad037769fbede2",
  measurementId: "G-TQFZK8EZV2",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { auth };
export default db;
